import { render, staticRenderFns } from "./PermProfile.vue?vue&type=template&id=19f656c2&scoped=true&"
import script from "./permProfile.ts?vue&type=script&lang=ts&"
export * from "./permProfile.ts?vue&type=script&lang=ts&"
import style0 from "./PermProfile.vue?vue&type=style&index=0&id=19f656c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f656c2",
  null
  
)

export default component.exports